import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    name: '系统响应',
    ownerIdProp: 'sfId',
    ownerTextProp: 'sfName',
    ownerType: 'SF',
    textProp: 'resTitle',
    type: 'FRES',
}
